<template>
  <div class="offering">
    <h2 class="is-size-4-touch">Recruitment Process Outsourcing</h2>
    <p>
      When performing Recruitment Performance Outsourcing, our company assumes
      the role of the client company’s internal recruitment cell for a part of
      the hiring cycle. We manage the complete hiring process, from job
      profiling to on-boarding new hires. We help our clients by improving time
      to hire, expanding the hiring pool, enhancing the quality of new hires,
      providing verifiable metrics, reducing costs, and improving statutory
      compliance.
    </p>
    <p>
      Our RPO team helps HR managers to pick and choose one or more of the below
      mentioned recruitment processes and outsource it as required:
    </p>
    <ul>
      <li>Identifying manpower needs and job profiling</li>
      <li>Advertising campaign and media planning</li>
      <li>Handling ad responses</li>
      <li>Screening, elimination, and shortlisting</li>
      <li>Conducting tests and interviews</li>
      <li>Checking references</li>
      <li>Salary negotiation</li>
      <li>Joining facilitation and on-boarding</li>
      <li>Orientation and induction</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "OfferingRPO",
  props: {},
};
</script>
